import React, { useState } from 'react';
import ScalperBot from "../components/scalperBot";
import DoRandomDeal from "../components/DoRandomDeal";
import { FormControl, InputLabel, MenuItem, Select, Box } from '@mui/material';

export default function Hustle() {
  const [strat, setStrat] = useState('Scalper');
  const options = {
    "Scalper": ScalperBot
  };
  const SelectedComponent = options[strat];

  return (
    <Box sx={{ p: 2 }}>
      <FormControl fullWidth>
        <InputLabel id="strategy-select-label">Strategy</InputLabel>
        <Select
          labelId="strategy-select-label"
          value={strat}
          label="Strategy"
          onChange={(e) => setStrat(e.target.value)}
        >
          <MenuItem value='Scalper'>Scalper</MenuItem>
        </Select>
      </FormControl>
      <Box sx={{ mt: 2 }}>
        <SelectedComponent />
      </Box>
    </Box>
  );
}
